export default __webpack_public_path__ + "static/media/Devin.b3b9ce63.jpg";